import { CompSelectCore } from '../core/forms/select/comp'

export const CompSelect = CompSelectCore
